<template>
  <div>
    <p>
      Är ett gavelskydd som skyddar gaveln vid påkörning. Påkörningsskydd är ett krav för att pallstället ska vara godkänt om du har trucktrafik i området.
    </p>
  </div>
</template>
<script>

import ImpactProtectorsInfo from "@/components/infotext/ImpactProtectorsInfo.vue";

export default {
  components: {
    ImpactProtectorsInfo
  }
}

</script>